export const SEQUENTIAL_MODALS = {
  AgreementInfo: 'agreementInfo',
  TutorialModal: 'tutorialModal',
  Advertisements: 'advertisement',
  MessageModal: 'messageModal',
  Recommend: 'recommend',
};

export const STATUS = {
  INIT: 'init',
  NOT_READY: 'not-ready',
  PROCESSING: 'processing',
  ALL_DONE: 'all-done',
};

export const MAX_DISPLAY_COUNT = 2;
